import { getRangeForEvent, isNotNil } from 'shared/src/utils';
import type { GoodsListCardItem } from '../utils/convertGoodsListItemToGoodsData';

/**
 * DISPLAY_GOODS / CLICK_GOODS / CLICK_LIKE_GOODS / CLICK_UNLIKE_GOODS 공통 파라미터
 * iOS `CommonProductCell.getAnalyticsLogging` + `goods.loggingModel`과 동일 구성
 */
export const getGoodsAnalytics = (
  pressed: GoodsListCardItem,
  index: number,
  params: {
    type: string;
    listId: string | undefined;
    listParams: string | undefined;
  },
) => {
  const item = pressed.item;

  return {
    SCREEN: params.type.toUpperCase(),
    LIST_ID: params.listId,
    LIST_INDEX: index,
    LIST_PARAMS: params.listParams,
    CATEGORY_SNO: item.category.sno.toString(),
    CATEGORY_NAME: item.category.name,
    CATEGORY_DEPTH: item.category.depth,
    STANDARD_CATEGORY_SNO: item.standard_category.sno.toString(),
    STANDARD_CATEGORY_NAME: item.standard_category.name,
    MARKET_SNO: item.market.sno.toString(),
    MARKET_NAME: item.market.name,
    MARKET_TYPE: item.market.market_type.name,
    GOODS_SNO: item.sno.toString(),
    GOODS_NAME: item.name,
    DELIVERY_TYPE: item.delivery_type.toUpperCase(),
    DISCOUNT_RATE: item.discount_rate,
    IS_AD: isNotNil(item.ad) ? '1' : '0',
    IS_NEW: item.is_new ? '1' : '0',
    IMAGE_BADGE_LIST: pressed.render.data.image_badge_list.map(b => b.type),
    NUDGING_DESCRIPTION: pressed.render.data.nudging_text ?? '',
    ORIGINAL_PRICE:
      item.first_page_rendering?.original_price ??
      item.linked_option.original_price,
    SALES_PRICE: item.price,
    SALES_PRICE_RANGE: getRangeForEvent({
      target: item.price,
      rangeUnit: 5000,
    }),
    REVIEW_COUNT: item.total_review_count,
    REVIEW_COUNT_RANGE: getRangeForEvent({
      target: item.total_review_count,
      rangeUnit: 50,
    }),
    REVIEW_RATING: item.positive_review_rate,
    LIKES_COUNT: 0,
    LIKES_COUNT_RANGE: '0',
    INDEX: index,
    ad: item.ad,
    ...pressed.logging.analytics,
  };
};
